import {
  SortableStateChangeItem,
  StateChangeItem,
} from '~/components/txn-display/state-change/types'

export const sortStateChangeItems = (
  items: SortableStateChangeItem[],
): StateChangeItem[] =>
  items
    .sort((a, b) => {
      if (a.categoryRank !== b.categoryRank)
        return a.categoryRank - b.categoryRank

      // For approvals, put "clear" (amount === 0) first, then sort by amount
      if (
        a.payload.state_change_type === 'approval' &&
        b.payload.state_change_type === 'approval'
      ) {
        const aIsClear = a.payload.amount === 0n
        const bIsClear = b.payload.amount === 0n
        if (aIsClear !== bIsClear) return aIsClear ? -1 : 1
      }

      if (a.collectionPriority !== b.collectionPriority)
        return a.collectionPriority - b.collectionPriority

      const usdComparison = compareNumbersDesc(a.usdValue, b.usdValue)
      if (usdComparison !== 0) return usdComparison

      const tokenAmountComparison = compareNumbersDesc(
        a.tokenAmountSortValue,
        b.tokenAmountSortValue,
      )
      if (tokenAmountComparison !== 0) return tokenAmountComparison

      const absoluteComparison = compareBigintsDesc(
        a.absoluteAmount,
        b.absoluteAmount,
      )
      if (absoluteComparison !== 0) return absoluteComparison

      return a.payload.id.localeCompare(b.payload.id)
    })
    .map((item) => item.payload)

const compareNumbersDesc = (a?: number, b?: number) => {
  if (a === undefined && b === undefined) return 0
  if (a === undefined) return 1
  if (b === undefined) return -1
  return b - a
}

const compareBigintsDesc = (a?: bigint, b?: bigint) => {
  if (a === undefined && b === undefined) return 0
  if (a === undefined) return 1
  if (b === undefined) return -1
  if (a === b) return 0
  return a > b ? -1 : 1
}
